import * as Sentry from "@sentry/react";
import { DialogsProvider } from "@toolpad/core/useDialogs";
import { useEffect } from "react";
import {
    createRoutesFromChildren,
    matchRoutes,
    BrowserRouter as Router,
    useLocation,
    useNavigationType,
} from "react-router";
import { AppRoutes } from "./AppRoutes";
import { ProcessingScopesManager } from "./components/frontend/ProcessingScopesManager";
import { ErrorResetBoundary } from "./components/shared/ErrorResetBoundary";
import { AuthProvider } from "./contexts/auth/AuthProvider";
import { ProcessingScopesProvider } from "./contexts/frontend/processing-scopes/ProcessingScopesProvider";
import {
    redactSignedStorageBreadcrumb,
    shouldCreateSentryRequestSpan,
} from "./utils/sentry-url-redaction";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
            shouldCreateSpanForRequest: shouldCreateSentryRequestSpan,
        }),
    ],
    beforeBreadcrumb: redactSignedStorageBreadcrumb,
    tracesSampleRate: 1.0,
});

const App = () => {
    return (
        <Router>
            <ErrorResetBoundary>
                <AuthProvider>
                    <ProcessingScopesProvider>
                        <DialogsProvider>
                            <AppRoutes />
                        </DialogsProvider>
                        <ProcessingScopesManager />
                    </ProcessingScopesProvider>
                </AuthProvider>
            </ErrorResetBoundary>
        </Router>
    );
};

export default App;
